import React from "react";

import validateForm from "../../lib/validateForm";
import Api from "../../lib/componentApi";

export default class ForgottenPassword extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formErrors: {
        email: ""
      },
      email: "",
      informationSection: false,
      active: false,
      showErrors: false
    };
  }
  componentDidMount() {
    const popup = document.getElementById("popup-bg");

    if (popup) {
      popup.addEventListener("click", () => this.onCloseForgottenPass(), false);
    }
  }
  onCloseForgottenPass = () => {
    const { handleCloseSection } = this.props;
    handleCloseSection("forgotPassSection");
  };
  handleSubmit = event => {
    event.preventDefault();
    const isValid = this.isValid();
    if (isValid) {
      const { email } = this.state;
      Api.post("/api/forgotPass", { email }, (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "forgot-pass-code");
        } else {
          if (response.status) {
            this.setState({
              informationSection: true
            });
            // window.location.href = 'https://www.burdiapp.com/personal';
          } else {
            console.log("status false forgot pass");
          }
        }
      });
    }
  };
  handleChange = event => {
    event.preventDefault();
    const input = event.target.id;
    this.setState(
      {
        [input]: event.target.value,
        showErrors: false
      },
      () => {
        const currentState = { [input]: this.state[input] };
        const inputError = validateForm(currentState, "forgotPass");
        const { formErrors } = this.state;
        formErrors[input] = inputError;
        this.setState({ formErrors }, () => {
          const { email, formErrors } = this.state;
          const errors = Object.values(formErrors).filter(Boolean);
          if (email && !errors.length) {
            this.setState({ active: true });
          } else {
            this.setState({ active: false });
          }
        });
      }
    );
  };
  isValid = () => {
    const { email, formErrors } = this.state;
    const errors = Object.values(formErrors).filter(Boolean);
    if (email && !errors.length) {
      return true;
    } else {
      this.setState(
        {
          showErrors: true
        },
        () => {
          return false;
        }
      );
    }
  };
  render() {
    const { handleCloseSection } = this.props;
    const {
      email,
      formErrors,
      active,
      informationSection,
      showErrors
    } = this.state;
    return (
      <div>
        <div className="modal-bg" id="popup-bg" />
        <div className="modal">
          <div className="sign-page forgot-page">
            {/* Header */}
            <div className="head-general with-back">
              <a
                href="javascript: void(0)"
                className="back"
                onClick={() => handleCloseSection("forgotPassSection")}
              >
                <img src="/png/chevron-left.png" />
              </a>
              <h4>Forgotten Password</h4>
              <a
                href="javascript: void(0)"
                className="close"
                onClick={() => handleCloseSection("forgotPassSection")}
              >
                <i className="icon icon-close" />
              </a>
            </div>
            {/* Header */}
            <div className="modal-body row center-sm">
              <div className="col-sm-8">
                {(informationSection && (
                  <div>
                    <p>
                      Enter your email below and we’ll send you a link to change your password.
                    </p>
                    <div className="">
                      <button
                        onClick={() => handleCloseSection("forgotPassSection")}
                        className={`btn btn-sign register-button active`}
                      >
                        <span>Ok.</span>
                      </button>
                    </div>
                  </div>
                )) || (
                  <form onSubmit={this.handleSubmit} className="Login">
                    <p>
                      Enter your email below and we’ll send you a link to change your password.
                    </p>
                    <div className="sm">
                      <div
                        className={`form-group ${(showErrors &&
                          formErrors["email"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="email"
                          className="form-input"
                          value={email}
                          type="email"
                          autoComplete="email"
                          autoCapitalize="none"
                          placeholder="Email"
                          onChange={this.handleChange}
                        />
                        <span>
                          {(showErrors &&
                            formErrors["email"] &&
                            formErrors["email"]) ||
                            ""}
                        </span>
                      </div>
                      <div className="">
                        <button
                          className={`btn btn-sign register-button ${(active &&
                            "active") ||
                            ""}`}
                          type="submit"
                        >
                          <span>Send the link</span>
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
              {/* .col-sm-8 */}
            </div>
            {/* .modal-body */}
          </div>
          {/* .sign-page */}
        </div>
        {/* .modal */}
      </div>
    );
  }
}
